<form (click)="debugForm(constructor.name)" (keydown)="(null)">
  <mat-form-field class="w-[calc(100%-64px)]">
    <mat-label class="text-xl font-semibold">Langue préférée</mat-label>
    <mat-select [formField]="formTree.language">
      @for (lang of supportedLanguages; track $index) {
        <mat-option [value]="lang">
          {{ lang | languageLabel }}
        </mat-option>
      }
    </mat-select>
    <mat-error>Langue invalide</mat-error>
  </mat-form-field>
</form>
